import { redirect, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/settings/')({
	beforeLoad: () => {
		throw redirect({ to: '/settings/profile' });
	},
});
